import React, { useEffect, useState } from 'react';
import { IntegrationProcessService } from '../../../Component/Api/IntegrationProcess/IntegrationProcessService';
import { DataTable } from '../../../Component/Common/Components/DataTable/DataTable';
import { ColumnSortOption } from '../../../Component/Model/Dto/ColumnSortOption';
import { Submissions } from '../../../Component/Model/Dto/VerificationAgency/IntegrationProcess/Submissions';
import { VaIntegrationStatus } from '../../../Component/Model/Enum/BEE123Enums';
import { EntriesPerPage } from '../../../Component/Model/Table/Table';
import { RejectedScorecardSubmissionMapper } from './ScorecardSubmissionManagementTableMapper';

export const RejectedSubmissionsPage = () => {

    const [entriesPerPage, setEntriesPerPage] = useState<EntriesPerPage>({ defaultValue: 10 });
    const [filteredItemsCount, setFilteredItemsCount] = useState<number>(0);
    const [totalItemsCount, setTotalItemsCount] = useState<number>(0);
    const [pageNumber, setPageNumber] = useState<number>(1);
    const [searchValue, setSearchValue] = useState<string>('');
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [scorecardSubmissionsData, setScorecardSubmissionsData] = useState<Submissions.SubmissionSearchResult[]>([])
    const [columnSortOption, setSortColumnOption] = React.useState<ColumnSortOption[]>([]);

    const scorecardSubmissonSearchRequest: Submissions.SubmissionSearchInput = {
        pageNumber: pageNumber,
        pageSize: entriesPerPage.defaultValue!,
        searchValue: searchValue,
        columnSortOptions: columnSortOption,
        status: VaIntegrationStatus.Rejected
    };

    const entriesPerPageChanged = (entriesPerPage: number) => {
        setEntriesPerPage({ defaultValue: entriesPerPage });
        setPageNumber(1);
    }
    const pageNumberChanged = (pageNumber: number) => {
        if (pageNumber !== 0) {
            setPageNumber(pageNumber);
        }
    }
    const searchValueChanged = (value: string) => {
        setSearchValue(value);
    }

    const columnSortingChanged = (sortOption: ColumnSortOption) => {
        setSortColumnOption([sortOption]);
        setPageNumber(1);
    }

    const fetchScorecardSubmission = async () => {
        setIsLoading(true);
        try {
            const response = await IntegrationProcessService.SearchSubmissions(scorecardSubmissonSearchRequest);
            setScorecardSubmissionsData(response.data.results);
            setTotalItemsCount(response.data.totalItemsCount);
            setFilteredItemsCount(response.data.filteredItemsCount);
    
        } catch (error) {
            console.log(error);
        } finally {
            setIsLoading(false);
        }
    }

    useEffect(() => {
        fetchScorecardSubmission();
    }, [entriesPerPage, searchValue, pageNumber, columnSortOption])

    const ScorecardSubmissionTableMapper = RejectedScorecardSubmissionMapper(scorecardSubmissionsData);
    return (
        <>
            <DataTable
                table={ScorecardSubmissionTableMapper}
                entriesPerPage={entriesPerPage}
                pageNumber={pageNumber}
                filteredItemsCount={filteredItemsCount}
                totalItemsCount={totalItemsCount}
                entriesPerPageChanged={entriesPerPageChanged}
                pageNumberChanged={pageNumberChanged}
                searchValueChanged={searchValueChanged}
                isLoading={isLoading}
                manualSorting={true}
                columnSortingChanged={columnSortingChanged}
                canSearch
            ></DataTable>
        </>
    )
}